module.exports = __webpack_public_path__ + "static/media/il.27337ce0.svg";